import styled from 'styled-components';

export const GetStartedModalStyles = styled.div`
  display: block;
  background: rgba(45, 50, 59, 0.8);
  .modal-body {
    padding: 0;
  }
  h5 {
    font-size: 1.5rem;
    font-weight: 300;
    text-align: center;
  }
  .modal-footer {
    align-items: center;
    justify-content: space-around;
  }
  .modal-body {
    p {
      text-align: center;
      font-weight: 300;
    }
  }
`;
